<ms-promo-item-list
    [arrow]="showArrows"
    [items]="items"
    [tracking]="tracking"
    [itemClass]="linkClass"
    [class]="itemListClass"
    [promotedCompetitionIdsMap]="promotedCompetitionIdsMap"
    [promotedSportIdsMap]="promotedSportIdsMap"
    [layout]="linkLayout"
    (itemClick)="setTrackingDetails($event)" />
